export { default } from "./LoundriesTable"